<template>
  <div id="app" relative>    
    <Transition >
      <div 
        class="loader text-xs-center" 
        v-if="loading" 
      >
        <v-progress-circular
          :size="70"
          :width="7"
          color="red"
          indeterminate
        ></v-progress-circular>
      </div>
    </Transition>
   <router-view/>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "app",
  components: {
  },
  computed: {
    ...mapState("loader", ["loading"])
  },
  mounted(){
    this.$store.dispatch('loader/done');
  }
};
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.loader {
  z-index: 1000;
  width: 100% !important;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.356);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

</style>
